<script lang="ts">
  import { setContext } from 'svelte';
  import Cookies from 'js-cookie';
  import UnsupportedBrowserModalPartial from '$components/common/partials/ModalPartials/UnsupportedBrowserModalPartial.svelte';
  import DynamicChildrenComponent from '$lib/components/DynamicChildrenComponent/DynamicChildrenComponent.svelte';
  import CountryDetectionModal from '$lib/components/CountryDetectionModal/CountryDetectionModal.svelte';
  import BalanceTextPartial from '$components/common/partials/BalanceTextPartial/BalanceTextPartial.svelte';
  import { DesignSystem } from '$lib/helpers/design-system';
  import type { BasePageProps } from './types';
  import countryDetectionHelper from '$lib/helpers/country-detection-helper';
  import { SQUARE_GEO_COOKIE_NAME } from '$lib/constants/cookie-constants';

  export let locale: string;
  export let sections: BasePageProps['sections'];
  export let countryDetectionModalPartialConfig: ModalPartialConfig;
  export let unsupportedBrowserModalPartialConfig: ModalPartialConfig;
  export let unsupportedBrowserModalBody: string = '';
  export let defaultLocales: DefaultLocales;
  export let supportedLocales: string[];
  export let supportedCountriesAndLangs: CountryAndLanguageNamesMap;
  export let subdivision1IsoCode: string;
  export let designSystem: DesignSystem;

  export let trackingConfig: Record<string, any>;
  export let gtmConfig: Record<string, any>;
  export let envConfig: Record<string, any>;
  export let featureFlagsConfig: Record<string, any>;

  setContext('designSystem', designSystem);
  setContext('locale', locale);
  setContext('enableImageLazyLoading', featureFlagsConfig['enable_image_lazy_loading']);

  const BudouxPartialPromise =
    locale === 'ja-JP' ? import('$components/common/partials/BudouxPartial/BudouxPartial.svelte') : null;

  if (envConfig) {
    envConfig.detected_country_code = countryDetectionHelper.extractCountryFromGeoCode(
      Cookies.get(SQUARE_GEO_COOKIE_NAME) ?? null
    );
  }
</script>

<svelte:head>
  {#if trackingConfig}
    <meta name="sq:tracking" content={JSON.stringify(trackingConfig)} />
  {/if}
  {#if gtmConfig}
    <meta name="sq:gtm" content={JSON.stringify(gtmConfig)} />
  {/if}
  {#if envConfig}
    <meta name="sq:environment" content={JSON.stringify(envConfig)} />
  {/if}
  {#if featureFlagsConfig}
    <meta name="sq:flags" content={JSON.stringify(featureFlagsConfig)} />
  {/if}
</svelte:head>

{#if BudouxPartialPromise}
  {#await BudouxPartialPromise then BudouxPartial}
    <svelte:component this={BudouxPartial.default} />
  {/await}
{/if}

<BalanceTextPartial />

{#if $$props.pageMetadata}
  <DynamicChildrenComponent children={$$props.pageMetadata} />
{/if}

<div class="BasePage" id="page" data-design-system={designSystem}>
  <CountryDetectionModal
    {locale}
    modalPartialConfig={countryDetectionModalPartialConfig}
    {supportedCountriesAndLangs}
    {defaultLocales}
    {supportedLocales}
  />
  <UnsupportedBrowserModalPartial
    {unsupportedBrowserModalBody}
    modalPartialConfig={unsupportedBrowserModalPartialConfig}
  />
  {#if sections}
    <DynamicChildrenComponent children={sections} />
  {/if}
</div>

<style lang="scss">
</style>
